<template>
    <div ref="content">
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle">{{$t('personal.mycollection')}}</div>
            <div class="padding-32">
                <div class="order_menu">
                    <div class="inline-block order_tab" :class="{'active':currenttap == item.type}" v-for="(item,index) in rankArr[currentlang]" @click="tapchoose(item)">
                        <span class="vertical-middle" :class="{'tapactivecolor':currenttap == item.type}">{{item.title}}</span>
                    </div>
                </div>
            </div>
            <div v-if="currenttap == 'report'">
                <div class="position_relative report_Item" style="height: 400px;margin-bottom: 24px;"  v-for="item in mycollectreport" @click="todetail('report',item)">
                    <div class="rank_reportL">
                        <div class="reportL_label">{{typedesc[item.type]}}{{$t('index.reportTitle')}}</div>
                        <div class="display_flex flex-direction_column justify-content_flex-justify report_left_height">
                            <div>
                                <div class="title_limit2 line2">{{item.title}}</div>
                                <div class="report_content">{{item.summary}}</div>
                            </div>
                            <div class="more_report">{{$t('rankindex.lookreport')}}</div>
                        </div>
                    </div>
                    <div class="rank_report" :style="{backgroundImage:'url('+ item.listImageLargePc +')'}"></div>
                    <div class="report_buystatus display_flex" v-if="!item.buyStatus">
                        <div class="flex_1 addrank">{{$t('modal.addcart')}}</div>
                        <div class="flex_1 buyrank">{{$t('modal.buynow')}}</div>
                    </div>
                </div>
                <div v-if="mycollectreport.length == 0" class="empty">
                    <img src="https://p1.fishqc.net/FqVLmUKK1YJNCfTM5QYuI7WTSf9X">
                    <div>{{$t('common.returnmessage.tips3')}}</div>
                </div>
            </div>
            <div v-if="currenttap == 'rank'">
                <div style="padding-bottom:40px;">
                    <div class="position_relative display_flex   flex-wrap_wrap">
                        <div class="rankitem" v-for="item in mycollectrank" @click="todetail('rank',item)">
                            <div class="coveritem" :style="{backgroundImage: 'url(' +  item.listImage+ ')'}">
                            </div>
                            <div class="sec_name">{{item.title}}</div>
                            <div class="date display_flex justify-content_flex-justify  align-items_center">
                                <div >{{formatTimefun(item.publishTime)}}</div>
                                <img src="../../assets/images/rang.png" width="16" height="16" >
                            </div>
                            <div class="buystatus display_flex" v-if="!item.buyStatus">
                                <div class="flex_1 addrank">{{$t('modal.addcart')}}</div>
                                <div class="flex_1 buyrank">{{$t('modal.buynow')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
               <div v-if="mycollectrank.length == 0" class="empty">
                    <img src="https://p1.fishqc.net/FqVLmUKK1YJNCfTM5QYuI7WTSf9X">
                    <div>{{$t('common.returnmessage.tips4')}}</div>
                </div>
            </div>
            <div v-if="currenttap == 'product'">
                <div class="display_flex   flex-wrap_wrap padding_bottom_104">
                    <div v-for="item in mycollectproduct" :class="['product_item',{'eng':currentlang == 'eng'}]" @click="toproductdetail(item)">
                        <div class="labelImg">
                            <img :src="labelarr['green']" alt="" v-if="Number(item.fishClass) == 10">
                            <img :src="labelarr['effect']" alt="" v-if="Number(item.efficacyAntiacne) || Number(item.efficacyAntiaging) || Number(item.efficacyMoisturizing) || Number(item.efficacyRepair) || Number(item.efficacyWhitening)">
                        </div>
                        <div class="productImg" :style="{backgroundImage:'url('+ item.img +')'}">
                            
                        </div>
                        <div class="padding_bottom_16">
                            <div class="limit2">{{item.prdName}}</div>
                        </div>
                        
                        <!-- <div class="productInfo display_flex justify-content_flex-justify">
                            <span>{{$t('product.price')}}:<span class="main">{{item.price}} {{item.currency}}</span></span>
                            <span>{{$t('index.address')}}:<span class="main">{{item.originplace}}</span></span>
                        </div> -->
                        <div class="productInfo display_flex justify-content_flex-justify" v-if="currentlang !== 'eng'">
                            <span>{{$t('product.price')}}：<span class="main">{{item.price}}{{item.currency}}</span></span>
                            <span>{{$t('product.address')}}：<span class="main">{{item.originplace}}</span></span>
                        </div>
                        <div v-if="currentlang == 'eng'">
                            <div class="productInfo display_flex justify-content_flex-justify">
                                <span class="flex_1">{{$t('product.price')}}：</span>
                                <span class="flex_1">{{$t('product.address')}}：</span>
                            </div>
                            <div class="productInfo display_flex justify-content_flex-justify" style="padding-top: 8px;">
                                <span class="flex_1 main">{{item.price}}{{item.currency}}</span>
                                <span class="flex_1 main">{{item.originplace}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="mycollectproduct.length == 0" class="empty">
                    <img src="https://p1.fishqc.net/FqVLmUKK1YJNCfTM5QYuI7WTSf9X">
                    <div>{{$t('common.returnmessage.tips5')}}</div>
                </div>
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.order_menu {
    background: #F8FBFD;
    height: 64px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #60DEB4;
    text-align: left;
    .order_tab {
        // width: 160px;
        padding: 0 32px;
        box-sizing: border-box;
        height: 60px;
        color: #A8A8AD;
        line-height: 60px;
        cursor: pointer;
        border-top: 4px solid #F8FBFD;
        text-align: center;

        &.active {
            background: #fff;
            border-top: 4px solid #60DEB4;
        }

    }
}


.suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding-top: 40px;
    padding-bottom: 32px;
    margin-bottom: 32px;
    border-bottom: 2px solid #F8FBFD;

}

.more {
    width: 246px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    letter-spacing: 4px;
    cursor: pointer;
    background: url('../../assets/images/arr.png') no-repeat 210px 20px;
    background-color: #FFFFFF;
}
// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0 0;
    box-sizing: border-box;

}

.empty{
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 50px;
    text-align: center;
    margin: 80px 0 0;
    padding-bottom: 80px;
    box-sizing: border-box;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
}

</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { collectlistApi } from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'
import {formatTime} from '@/utils/other.js'
import Modal from '@/components/Modal.vue'
export default {
    name: '',
    components: {
        banner,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            rankArr: {
                'chs':[
                    {
                        title: this.$t('index.rankTitle'),
                        type: 'rank',
                        typNum:'12',
                        icon: '',
                        iconActive: ''
                    },
                    {
                        title:this.$t('index.reportTitle'),
                        type: 'report',
                        typNum:'13',
                        icon: '',
                        iconActive: ''
                    },
                    {
                        title: this.$t('index.productTitle'),
                        type: 'product',
                        typNum:'1456',
                        icon: '',
                        iconActive: ''
                    },
                ],
                'cht':[
                    {
                        title: this.$t('index.rankTitle'),
                        type: 'rank',
                        typNum:'12',
                        icon: '',
                        iconActive: ''
                    },
                    {
                        title:this.$t('index.reportTitle'),
                        type: 'report',
                        typNum:'13',
                        icon: '',
                        iconActive: ''
                    },
                    {
                        title: this.$t('index.productTitle'),
                        type: 'product',
                        typNum:'1456',
                        icon: '',
                        iconActive: ''
                    },
                ],
                'eng':[
                    {
                        title: this.$t('index.rankTitle'),
                        type: 'rank',
                        typNum:'12',
                        icon: '',
                        iconActive: ''
                    },
                    // {
                    //     title:this.$t('index.reportTitle'),
                    //     type: 'report',
                    //     typNum:'13',
                    //     icon: '',
                    //     iconActive: ''
                    // },
                    {
                        title: this.$t('index.productTitle'),
                        type: 'product',
                        typNum:'1456',
                        icon: '',
                        iconActive: ''
                    },
                ]

            },
            currenttap: 'rank',
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination1'
                },
                uniqueNavElements: false,
                
                // Some Swiper option/callback...
            },
            currentpage:1,
            mycollectrank:[],
            mycollectreport:[],
            mycollectproduct:[],
            currentlang:''
        }
    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y-M-D')
            }
        }
    },
    watch:{
        'mycollectrank':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
               
            })
        },
        'mycollectreport':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
               
            })
        },
        'mycollectproduct':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
               
            })
        },

    },
    mounted() {
        this.currentlang = window.localStorage.getItem("LOCALE")
        this.mycollectrank = []
        this.mycollectreport = []
        this.mycollectproduct = []
        this.currenttap =  this.$route.query.type
        console.log("打印",this.currenttap)
        
        switch(this.currenttap){
            case 'rank':
            this.colloctlist('12') 
            break;
            case 'report':
            this.colloctlist('13') 
            break;
            case 'product':
            this.colloctlist('1456') 
            break;
        }
    },
    methods: {
        tapchoose(item) {
            // 类型，1榜单，2报告
            this.currenttap = item.type
            this.mycollectrank = []
            this.mycollectreport = []
            this.mycollectproduct = []
            this.colloctlist(item.typNum)
           
        },
        // 我的收藏
        colloctlist(type){
            collectlistApi({
                favtype:type,
                page: this.currentpage,
                limit:8,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    if(type == 12){
                        this.mycollectrank = this.mycollectrank.concat(res.data.list)
                        console.log(this.mycollectrank)
                    }

                    if(type == 13){
                        this.mycollectreport = this.mycollectreport.concat(res.data.list)
                        console.log(this.mycollectreport)
                    }

                    if(type == 1456){
                        this.mycollectproduct = this.mycollectproduct.concat(res.data.list)
                        console.log(this.mycollectproduct)
                    }
                    
                }else{

                    // this.toast(res.message)
                    
                }
            })
        },
        todetail(type,item){
            console.log(type,item)
            switch(type){
                case  'report':
                    if(item.buyStatus){  //已购买状态，进入详情
                        this.gorouter('/report/detail/'+item.prdUnionId)
                    }else{   //弹出导购弹窗，有previewVideo，弹窗视频导购，否则图片导购

                        this.$refs.modaltoast.show({
                            type:'guide',  //弹窗类型，guide:导购页
                            itemtype:'2',    //报告
                            itemdata:item
                        });
                    }
                break;
                case  'rank':
                    if(item.buyStatus){  //已购买榜单，进入详情
                        this.gorouter('/rank/detail/'+item.prdUnionId)
                    }else{
                        this.$refs.modaltoast.show({
                            type:'guide',
                            itemtype:'1',    //榜单
                            itemdata:item
                        });
                    }
                break;
            }
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
        getmaterial(){

        },

    }
}
</script>